import(/* webpackMode: "eager" */ "/usr/local/jenkins/workspace/global-rentacar-frontend-build-and-publish/apps/mypage/app/default/[lng]/error.tsx")